import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    i18nEnabled: false,
    themeSwitcherEnabled: false,
    isLoaded: false,
};

const featureSlice = createSlice({
    name: 'features',
    initialState,
    reducers: {
        setFeatureFlags: (state, action) => {
            const flags = action.payload.results;

            if (!flags || flags.length === 0) {
                state.i18nEnabled = false;
                state.themeSwitcherEnabled = false;
                state.isLoaded = true;
                return;
            }

            flags.forEach(flag => {
                if (flag.key === 'FEATURE_I18N_ENABLED') {
                    console.log('Setting i18nEnabled to', flag.enabled);
                    state.i18nEnabled = flag.enabled;
                }
                if (flag.key === 'FEATURE_THEME_SWITCHER_ENABLED') {
                    state.themeSwitcherEnabled = flag.enabled;
                }
            });

            state.isLoaded = true;
        },
        resetFeatureFlags: () => initialState,
    },
});

export const { setFeatureFlags, resetFeatureFlags } = featureSlice.actions;
export default featureSlice.reducer;